import { useEffect } from 'react';
export function useOutsideClick(ref, callback, disabled, useDisableOnPortalClick) {
    if (disabled === void 0) { disabled = false; }
    if (useDisableOnPortalClick === void 0) { useDisableOnPortalClick = false; }
    useEffect(function () {
        function handleClickOutside(event) {
            if (!disabled && ref && ref.current && !ref.current.contains(event.target)) {
                var disableOnPortalClick_1 = false;
                if (useDisableOnPortalClick) {
                    event.composedPath().forEach(function (target) {
                        var _a;
                        var el = target;
                        try {
                            if ((el === null || el === void 0 ? void 0 : el.id) === 'portal' ||
                                (el === null || el === void 0 ? void 0 : el.id) === 'hamburger-menu' ||
                                ((_a = el === null || el === void 0 ? void 0 : el.className) === null || _a === void 0 ? void 0 : _a.includes('fs-modal-content'))) {
                                disableOnPortalClick_1 = true;
                            }
                        }
                        catch (e) { }
                    });
                }
                if (!disableOnPortalClick_1) {
                    callback();
                }
            }
        }
        document.addEventListener('mousedown', handleClickOutside);
        return function () {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [ref, disabled]);
}
